var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('AccOrderList',{attrs:{"contact-id":_vm.contactId}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }